import React, { useEffect, useState } from "react"
import { useHistory } from "react-router"
import { getManageStaffDetailsById, getRmoApprovalRequestDetails } from "../../../../core/services/api"
import { useSelector } from "react-redux"
import "./RMOPendingAppointmentComponent.scss"
import PermissionUtils from "../../../../core/store/utils/PermissionUtils"
import { MocUserRole } from "../../../../core/services/models/Enums"
import { getApprovalPendingRasieRequests, getDiscountPendingRaiseRequests } from "core/services/api/mrdService"
import moment from "moment"

export default function RMOPendingAppointmentComponent() {

  const [approvalPendingResult, setApprovalPendingResult] = useState<any>()
  const [discountApproval, setDiscountApproval] = useState<any>()
  const [staffDetails, setStaffDetails] = useState<any>()

  const userRole = useSelector((state: any) => state?.user?.role)
  const userDetail = useSelector((state: any) => state?.user?.userDetail)

  const history = useHistory()
  useEffect(() => {
    if (userDetail?.id) {
      getManageStaffDetailsById(userDetail?.id)
        .then((res: any) => {
          setStaffDetails(res)
        })
        .catch((err: any) => console.log(err?.message))
    }
  }, [userDetail])

  useEffect(() => {
    if (staffDetails) {
      fetchRmoApprovalRequestDetails()
    }
  }, [staffDetails])

  function fetchRmoApprovalRequestDetails() {
    if (userRole === MocUserRole?.MRD) {
      //API for pending mrd file requisition approval requests
      getApprovalPendingRasieRequests()
        .then((res: any) => {
          setApprovalPendingResult(res)
        })
        .catch((err: any) => console.error(err?.message))
    }
    else if (userRole === MocUserRole?.CENTER_ADMIN) {
      //API for pending mrd file requisition approval requests
      if (staffDetails && staffDetails?.primaryRole === MocUserRole.CENTER_ADMIN) {
        getDiscountPendingRaiseRequests()
          .then((res: any) => {
            setDiscountApproval(res)
          })
          .catch((err: any) => console.error(err?.message))
      } else {
        setDiscountApproval([])
        setApprovalPendingResult([])
      }
    }
    else {
      getRmoApprovalRequestDetails(userRole === MocUserRole.RMO ? `?rmoId=${userDetail?.id}` : userRole === MocUserRole.CONSULTANT ? `?consultantId=${userDetail?.id}` : '')
        .then((res) => {
          setApprovalPendingResult(res?.filter((each: any) => each?.status === "PENDING"))
        })
        .catch((err) => {
          console.error("Err", err)
        })
    }
  }

  const handleViewAll = async (id: any, patientId: any, recordId: any, invoiceId: any, type: any) => {
    if (userRole === MocUserRole?.MRD) {
      //Redirect to approvals page
      history.push({
        pathname: "/mrdApprovalRequest",
        state: {
          idValue: id,
          patientIdValue: patientId,
          recordIdValue: recordId,
        },
      })
    }
    if (userRole === MocUserRole?.CONSULTANT || userRole === MocUserRole?.CENTER_ADMIN) {
      if (type == "consultant") {
        history.push({
          pathname: "/consultantApprovalRequest",
          state: {
            idValue: id,
            patientIdValue: patientId,
            recordIdValue: recordId,
          },
        })
      }
      else if (type == "consultantDiscount") {
        history.push({
          pathname: `/discountApprovalRequest/${id}/${invoiceId}`,
          state: {
            idValue: id,
            invoiceId: invoiceId,
          },
        })
      }
    }
  }

  const generateAppointmentList = (sliceValue: number) => {
    return (
      <div className="appointment-list">
        {discountApproval?.slice(sliceValue)?.map((item: any) => {
          return (
            <div className="col-md-12 row m-0 each-appointment">
              <div className="col-md-2 textLabel">{item?.total?.toFixed(2)}</div>
              <div className="col-md-1 p-0 textLabel"> {parseFloat(item?.discount)?.toFixed(2)}%</div>
              <div className="col-md-2 p-0 textLabel">{item.patientName}</div>
              <div className="col-md-3 p-0 textLabel">{item?.approver}</div>
              <div className="col-md-3 p-0 textLabel">{item?.approvalStatus}</div>
              <div className="col-md-1 p-0 deleteLabel cursor-pointer">
                <img
                  className="iconButton"
                  alt="view"
                  src="../../assets/images/CRedit.svg"
                  width="30"
                  onClick={() =>
                    handleViewAll(item?.id, item?.approverId, item?.recordId, item?.invoiceId, "consultantDiscount")
                  }
                />
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  useEffect(() => {
    if (userDetail?.id) {
      getManageStaffDetailsById(userDetail?.id)
        .then((res: any) => {
          setStaffDetails(res)
          fetchRmoApprovalRequestDetails();
        })
        .catch((err: any) => console.error(err?.message))
    }
  }, [userDetail])

  return (
    <div className="rmo-pending-appointment-component-wrapper">
      <div className="d-flex header-section">
        <div className="header">Pending Approval Request</div>
        <div
          className="view-all"
          onClick={() => {
            history.push("/viewAllRequest")
          }}
        >
          View All
        </div>
      </div>
      <div className="appointment-list">
        {
          userRole === MocUserRole.MRD ?
            <div className="appointment-list">
              {approvalPendingResult?.slice(-1)?.map((item: any) => {
                return (
                  <div className="col-md-12 row m-0 each-appointment">
                    <div className={`${userRole === MocUserRole.CONSULTANT ? 'col-md-2' : 'col-md-3'} col-md-2 p-0 textLabel text-truncate`}>{item?.formData?.dateOfApplication && moment(item?.formData?.dateOfApplication).format("DD-MM-YYYY")}</div>
                    <div className="col-md-3 p-0 textLabel">
                      {item?.formData?.RequstedByName}
                    </div>
                    <div className="col-md-3 p-0 textLabel">{item?.formData?.raiseRequestPatientId}</div>
                    <div className="col-md-3 p-0 textLabel">{item?.formData?.AccessTo} {item?.formData?.AccessTo[0] === "Specify If Any:" && item?.formData?.specificFiles?.join(",")}</div>
                    {userRole === MocUserRole.CONSULTANT && (
                      <div className="col-md-1 p-0 deleteLabel cursor-pointer">
                        <img
                          className="iconButton"
                          alt="view"
                          src="../../assets/images/CRedit.svg"
                          width="30"
                          onClick={() =>
                            handleViewAll(item?.id, item?.patientId, item?.recordId, item?.id, "MRD")
                          }
                        />
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
            :
            <div className="appointment-list">
              {approvalPendingResult?.slice(-1)?.map((item: any) => {
                return (
                  <div className="col-md-12 row m-0 each-appointment">
                    <div className={`${userRole === MocUserRole.CONSULTANT ? 'col-md-2' : 'col-md-3'} col-md-2 p-0 textLabel text-truncate`}>{item?.patientMocId}</div>
                    <div className="col-md-3 p-0 textLabel">  {PermissionUtils.displayPatientName(
                      userRole,
                      item,
                      true,
                      null,
                      null
                    )}</div>
                    <div className="col-md-3 p-0 textLabel">{item?.rmoName}</div>
                    <div className="col-md-3 p-0 textLabel">{item?.approvalFor}</div>
                    {userRole === MocUserRole.CONSULTANT && (
                      <div className="col-md-1 p-0 deleteLabel cursor-pointer">
                        <img
                          className="iconButton"
                          alt="view"
                          src="../../assets/images/CRedit.svg"
                          width="30"
                          onClick={() =>
                            handleViewAll(item?.id, item?.patientId, item?.recordId, item?.id, "consultant")
                          }
                        />
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
        }
        {userRole === MocUserRole.CONSULTANT && (generateAppointmentList(-1))}
        {userRole === MocUserRole.CENTER_ADMIN && (generateAppointmentList(-15))}
      </div>
    </div>
  )
}
